import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TranslocoService } from '@ngneat/transloco';

@Injectable({
  providedIn: 'root',
})
export class FilesService {
  constructor(private translocoService: TranslocoService) {}
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getFilesFromFileList = (fileList: FileList): File[] => {
    return Object.values(fileList);
  };

  loadFileData(file: File): Observable<string> {
    const fr = new FileReader();
    return new Observable(subscribe => {
      if (this.extensionFile(file?.name).toLowerCase() !== 'csv') {
        subscribe.error(this.translocoService.translate('translocoOverbooking.errors.notCorrectFormatFile'));
      } else {
        // eslint-disable-next-line functional/immutable-data
        fr.onload = () => {
          if (!fr.error) {
            subscribe.next(fr.result as string);
          } else {
            subscribe.error(fr.error);
          }
        };
        fr.readAsText(file);
      }
    });
  }

  extensionFile(name: string): string {
    return name ? name.split('.').slice(-1).join('.') : '';
  }
}
